import Vue from "vue";
import VueGtag from "vue-gtag";

import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";

require("./plugins/font-awesome.js");
require("./plugins/axios");
require("./plugins/vee-validate");

// Import globals
import VueHead from "vue-head";
Vue.use(VueHead);

import VueVirtualScroller from "vue-virtual-scroller";
Vue.use(VueVirtualScroller);

import numeral from "numeral";
Vue.filter("number", function(value) {
  return numeral(value).format("0,0");
});

Vue.filter("dateTime", function(value) {
  return new Date(value).toLocaleString('en-US', {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
});

import DatetimePicker from "vuetify-datetime-picker";
Vue.use(DatetimePicker);

import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

// Configure
Vue.config.productionTip = false;

Vue.use(VueGtag, {
  config: { id: "G-469DT7JC6D" },
});

// Start
new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
